export enum Moduller {
  YeniBasvuru = 'YeniBasvuru',
  BasvuruListele = 'BasvuruListele',
  BasvuruDuzenle = 'BasvuruDuzenle',
}

export interface OgrenciSecimModel {
  tcNo?: string;
  yerineGirisMi?: boolean;
  islemYapilanKisi?: string;
}
